import _ from 'lodash';
import {Map} from 'immutable';
import update from 'immutability-helper';
import {makeActionCreator} from 'crazyEditor/redux/helpers';
import {STATUS_FILTERS} from 'MyAccount/Listings/consts';
import {Channels} from 'cl-api';
const UPDATE_USER = 'realTimeDB/UPDATE_USER';
const UPDATE_LISTINGS_PAGE_SELLERS = 'realTimeDB/UPDATE_LISTINGS_PAGE_SELLERS';
const ADD_SELLER = 'realTimeDB/ADD_SELLER';
const REMOVE_SELLER = 'realTimeDB/REMOVE_SELLER';
const UPDATE_NOTIFICATIONS = 'realTimeDB/UPDATE_NOTIFICATIONS';

export default function reducer(state = {}, action = {}) {
  let updatedState;
  switch (action.type) {
    case UPDATE_LISTINGS_PAGE_SELLERS:
      if (state.listingsPage) {
        return update(state, {
          listingsPage: {
            listings: {
              $apply: listings =>
                _.mapValues(action.payload.listingsPage, (sellerData, sellerId) => ({
                  ...listings[sellerId],
                  ...sellerData,
                  ..._.mapValues(_.pick(sellerData, STATUS_FILTERS), (listingsDataForStatusFilter, statusFilter) => {
                    if (listings[sellerId] && listings[sellerId][statusFilter]) {
                      return listings[sellerId][statusFilter];
                    }
                    return {
                      ...listingsDataForStatusFilter,
                      listings: new Map(listingsDataForStatusFilter.listings),
                    };
                  }),
                })),
            },
          },
          accountPage: {
            accounts: {
              $apply: accounts => _.merge({}, accounts, _.keyBy(action.payload.accountPage, 'UserID')),
            },
          },
        });
      }
      return update(state, {
        accountPage: {
          accounts: {
            $apply: accounts => _.merge({}, accounts, _.keyBy(action.payload.accountPage, 'UserID')),
          },
        },
      });
    case ADD_SELLER:
      switch (action.channel) {
        case Channels.EBay:
          // TODO move connect ebay account logic here from
          updatedState = state;
          break;
        case Channels.Amazon:
          updatedState = action.error
            ? update(state, {
                accountPage: {
                  lastAmazonError: {
                    $set: action.error,
                  },
                },
              })
            : update(state, {
                accountPage: {
                  amazonAccounts: {
                    $apply: amazonAccounts => {
                      return {...amazonAccounts, [action.sellerData.amazonSellerId]: action.sellerData};
                    },
                  },
                },
              });
          break;
        default:
          updatedState = state;
          break;
      }
      return updatedState;
    case REMOVE_SELLER:
      switch (action.channel) {
        case Channels.EBay:
          updatedState = update(state, {
            accountPage: {
              accounts: {
                $apply: accounts => _.omit(accounts, action.sellerId),
              },
            },
            listingsPage: {
              listings: {
                $apply: listings => _.omit(listings, action.sellerId),
              },
            },
          });
          break;
        case Channels.Amazon:
          updatedState = update(state, {
            accountPage: {
              amazonAccounts: {
                $apply: amazonAccounts => _.omit(amazonAccounts, action.sellerId),
              },
            },
          });
          break;
        default:
          updatedState = state;
          break;
      }
      return updatedState;
    case UPDATE_USER:
      let {userData} = action;
      if (_.isEmpty(userData.tags)) {
        userData = {
          ...userData,
          tags: [],
        };
      }
      return update(state, {
        user: {
          $apply: user => _.merge({}, user, userData),
        },
      });
    case UPDATE_NOTIFICATIONS:
      const {notifications} = action;
      return update(state, {
        user: {
          notifications: {
            $set: notifications,
          },
        },
      });
    default:
      break;
  }
  return state;
}

export const realTimeUpdateUser = makeActionCreator(UPDATE_USER, 'userData');
export const updateListingsPageSellers = makeActionCreator(UPDATE_LISTINGS_PAGE_SELLERS, 'payload');
export const addSeller = makeActionCreator(ADD_SELLER, 'channel', 'sellerData', 'error', 'marketplaceIds');
export const removeSeller = makeActionCreator(REMOVE_SELLER, 'channel', 'sellerId');
export const updateNotifications = makeActionCreator(UPDATE_NOTIFICATIONS, 'notifications');
